import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

const Blur = styled.div<{ activate?: boolean; blurValue?: number }>`
  ${({ activate = true, blurValue = 3 }): FlattenSimpleInterpolation =>
    activate
      ? css`
          filter: blur(${blurValue}px);
          opacity: 0.4;
          pointer-events: none;
          user-select: none;
        `
      : css``}
`

export default Blur
